export default "__VITE_ASSET__BJd5n5MD__"